import {
    faEnvelope,
    faEnvelopeCircleCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { useState } from 'react';
import { ENVIOS_API } from '../../../shared/services/envios';
import { toast } from 'react-toastify';
import { CircularProgress } from '@mui/material';

const EmailsNoSent = ({ results }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isSent, setIsSent] = useState(
        results.reduce((acc, envio) => {
            acc[envio.envio_id] = false;
            return acc;
        }, {})
    );
  
    const handleSendEmail = async (envioId) => {
        if (isLoading) return;
        setIsLoading(envioId);
        try {
            const res = await ENVIOS_API.sendEmailToProvider(envioId);
            if (res.success) {
                return setIsSent({
                    ...isSent,
                    [envioId]: true,
                });
            }
            toast.error('No se ha podido enviar el email.');
        } catch (e) {
            toast.error(e.message);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="envio-detalle-modal">
            <div className="table-responsive">
                <table className="table">
                    <thead>
                        <tr>
                            <th colSpan={2}>#</th>
                            <th className="text-center" colSpan={2}>
                                fecha
                            </th>
                            <th className="text-center" colSpan={2}>
                                cliente
                            </th>
                            <th className="text-center" colSpan={3}>
                                pieza
                            </th>
                            <th className="text-center" colSpan={2}>
                                proveedor
                            </th>
                            <th className="text-center" colSpan={2}>
                                codigo transporte
                            </th>
                            <th className="text-center" colSpan={1}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {results?.map((envio) => (
                            <tr key={envio?.envio_id}>
                                <td colSpan={2}>{envio?.numero}</td>
                                <td className="text-center" colSpan={2}>
                                    {moment(envio?.fecha).format(
                                        'DD-MM-YYYY HH:mm'
                                    )}
                                </td>
                                <td colSpan={2}>{envio?.cliente}</td>
                                <td colSpan={3}>{envio?.nombrePieza}</td>
                                <td className="text-center" colSpan={2}>
                                    {envio?.proveedor}
                                </td>
                                <td className="text-center" colSpan={2}>
                                    {envio?.codigo_transporte}
                                </td>
                                <td
                                    className="text-center"
                                    colSpan={1}
                                    title="Enviar email"
                                    style={{ cursor: 'pointer', color:"#215732" }}
                                >
                                    {isLoading === envio?.envio_id ? (
                                        <CircularProgress
                                            size="20px"
                                            color="inherit"
                                        />
                                    ) : (
                                        <FontAwesomeIcon
                                            icon={
                                                isSent[envio?.envio_id]
                                                    ? faEnvelopeCircleCheck
                                                    : faEnvelope
                                            }
                                            size="2x"
                                            onClick={() =>
                                                handleSendEmail(envio?.envio_id)
                                            }
                                        />
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EmailsNoSent;
